import { createSlice } from "@reduxjs/toolkit";

const SUPPORTED_LANGUAGES = ["en", "fr"];
const DEFAULT_LANGUAGE = "en";

const savedLang = localStorage.getItem("lang");

const initialState = {
  language: SUPPORTED_LANGUAGES.includes(savedLang) ? savedLang : DEFAULT_LANGUAGE,
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    changeLanguage: (state, action) => {
      const lang = SUPPORTED_LANGUAGES.includes(action.payload)
        ? action.payload
        : DEFAULT_LANGUAGE;
      state.language = lang;
      localStorage.setItem("lang", lang);
    },
  },
});

export const { changeLanguage } = languageSlice.actions;

export default languageSlice.reducer;